// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3iPX5qNrQfSHDKzgZMmj6E{height:100vh;display:flex;flex-direction:column;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._3AJhnO_0YZl4uzO6yI-sP_{flex:1;margin-top:-2.42857rem}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "_3iPX5qNrQfSHDKzgZMmj6E",
	"base__tabs": "_3AJhnO_0YZl4uzO6yI-sP_"
};
export default ___CSS_LOADER_EXPORT___;
